import api from "@sim/services/api";
import router from "@sim/router";
import localStorage from "@sim/services/storage";
import Login from "./Forms/Login.vue";
import Register from "./Forms/Register.vue";
import SingleStep from "@sim/components/Partials/SingleStep.vue";
import StepWrapper from "@sim/components/Partials/StepWrapper.vue";
import stepsMixin from "@sim/mixins/stepsMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [stepsMixin],

  components: {
    Login,
    Register,
    SingleStep,
    StepWrapper,
  },

  data() {
    return {
      showForm: false,
      hasAccount: false,
      prefix: localStorage.get('locale', true) ? '/'+localStorage.get('locale', true) : '/de',
    };
  },

  computed: {
    ...mapGetters(["steps"]),

    currentComponent() {
      return this.hasAccount ? "Login" : "Register";
    },
  },

  mounted() {
    localStorage.save('page-step', '2', true);

    this.prepareStep2();
  },

  methods: {
    prepareStep2() {
      api
        .get("/public-api/prepare-sim/2/" + localStorage.get("page-step", true))
        .then((response) => {})
        .catch((error) => {
          localStorage.save("token", "", true);
          this.$swal(this.$i18nApi.t("messages.error"));
          router.push(this.prefix+"/sim-registration/1");
        });
    },

    proceedToNextStep() {
      this.$refs.childComponent.submitData();
    },
  }
};
